import React from 'react';
import { PortfolioBlog } from '../api/API';
import BlogCard from './BlogCard';
import '../assets/css/BlogCard.css';
import { useTranslate } from '../services/translation';

interface BlogListProps {
  blogs: PortfolioBlog[];
  limit?: number;
  showViewMore?: boolean;
  onViewMore?: () => void;
}

const BlogList: React.FC<BlogListProps> = ({
  blogs,
  limit,
  showViewMore = false,
  onViewMore,
}) => {
  const { translate } = useTranslate();
  const displayedBlogs = limit ? blogs.slice(0, limit) : blogs;

  if (blogs.length === 0) {
    return (
      <div className="blog-list-empty">
        <p className="light">{translate("common.no_blog_available")}</p>
      </div>
    );
  }

  return (
    <div className="blog-list-container">
      <div className="blog-grid">
        {displayedBlogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>

      {showViewMore && blogs.length > displayedBlogs.length && onViewMore && (
        <div className="blog-view-more">
          <button className="btn-view-more" onClick={onViewMore}>
            {translate("common.view_more_blogs")}
          </button>
        </div>
      )}
    </div>
  );
};

export default BlogList;
